import { uploadImage } from "../../../api/image"

const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/svg+xml",
]

export const isAcceptedImageFile = (file: File) =>
  ACCEPTED_IMAGE_TYPES.includes(file.type)

export const uploadEditorImage = async (file: File): Promise<string> => {
  if (!isAcceptedImageFile(file)) {
    throw new Error("Invalid file type. Use JPG, PNG, GIF, WebP, or SVG.")
  }

  const formData = new FormData()
  formData.append("file", file, file.name)

  const response = await uploadImage(formData)
  const url = response.data?.data?.final_signed_url

  if (typeof url !== "string") {
    throw new Error("Invalid response from server")
  }

  return url
}
